<template>

  <div id="app">

    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>

      <v-card color="grey lighten-5" flat>

        <v-layout row wrap>

          <v-flex xs12 md12 sm12>

            <v-toolbar size="120px" dark color="info">

              <v-toolbar-title>{{$t('Customer-Profitability-With-Payment')}}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet" :label="$t('Search')"

                append-icon="search"></v-text-field>

                <v-btn color="pink lighten-1" dark @click="openMailDialog" small>

  <v-icon left>email</v-icon> Mail Gönder

</v-btn>

              <v-menu bottom="" left>

                <v-btn slot="activator" dark icon>

                  <v-icon>more_vert</v-icon>

                </v-btn>

                <v-list>

                  <v-list-tile @click="getListHtml()">

                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>



                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">

                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>

                </v-list>

              </v-menu>

            </v-toolbar>

          </v-flex>

<!-- MAIL GÖNDER DIALOG -->

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>

  <v-card>

    <v-toolbar dense flat color="info" dark>

      <v-toolbar-title>Mail Gönder</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>

    </v-toolbar>

    <v-card-text>

      <v-form ref="mailForm" v-model="mailValid" lazy-validation>

        <v-layout wrap>

          <v-flex xs12>

            <v-text-field

              v-model="mailPayload.To"

              label="Kime (e-posta)"

              :rules="[rules.required, rules.email]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgencyName"

              label="Agency Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.DocType"

              label="Doc Type (sabit)"

              :rules="[rules.required]"

              :disabled="true"

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgentFullName"

              label="Agent Full Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12>

            <v-textarea

              v-model="mailPayload.CustomBody"

              label="Mesaj"

              :rules="[rules.required]"

              auto-grow

              rows="3"

            ></v-textarea>

          </v-flex>

        </v-layout>

      </v-form>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>

      <v-btn

        color="info"

        :loading="mailLoading"

        :disabled="!mailValid || mailLoading"

        @click="sendMail"

      >

        <v-icon left>send</v-icon>Gönder

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>



          <v-container fluid>

            <v-layout row wrap>





              <v-flex xs12 sm6 md6 pa-1>

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">add_comment</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm3 md12>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{genelToplamlar.ToplamVadeFark | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>



                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="caption font-weight-bold"> {{ $t('Total-Delay-Interest') }}</span>

                    <v-spacer></v-spacer>

                  </v-card-actions>

                </v-card>

              </v-flex>

              <v-flex xs12 sm6 md6 pa-1>

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">add_comment</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm3 md12>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{genelToplamlar.ToplamTutar | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>



                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="caption font-weight-bold"> {{$t('totalamount')}}</span>

                    <v-spacer></v-spacer>

                  </v-card-actions>

                </v-card>

              </v-flex>

            </v-layout>

          </v-container>



          <v-container fluid>

            <v-layout row wrap>

              <v-flex pb-3 xs12 sm12 md12>

                <v-card flat>

                  <v-form ref="formgunluksatis" v-model="valid" lazy-validation>

                    <v-layout row wrap>

                      <v-flex pb-3 xs12 sm12 md12>

                        <v-card flat>

                          <v-layout row wrap>

                            <v-flex xs12 sm6 pt-2 md2>

                              <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"

                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"

                                v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>

                            </v-flex>

                            <v-flex xs12 pt-2 sm6 md2>

                              <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"

                                :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"

                                v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>

                            </v-flex>

                            <v-flex xs1 pt-2 sm12 md2>

                                  <cariaracomp v-bind:etiket="$t('Accound-Code')" v-bind:value="Rapor.Cari.Kod" :loading="loading" v-bind:zorunlumu="true"

                                  v-model="Rapor.Cari.Kod"></cariaracomp>

                            </v-flex>

                            <v-flex pt-2>

                              <v-layout align-center="">

                                <div v-if="load1">

                                  <v-btn color="info" @click="getList()" fab small="" dark>

                                    <v-icon>search</v-icon>

                                  </v-btn>

                                </div>

                                <div v-if="progress">

                                  <v-layout align-center="">

                                    <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>

                                  </v-layout>

                                </div>

                                <v-badge color="white" :overlap="true">

                                  <template v-slot:badge>

                                    <v-icon v-if="filtrevarmi" large color="green">

                                      check_circle_outline </v-icon>

                                  </template>

                                  <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"

                                    @click="filtrele()" color="info" fab dark>

                                    <v-icon>filter_list</v-icon>

                                  </v-btn>

                                  <v-tooltip bottom="" :activator="el" v-model="tooltip">

                                    <span>{{$t('Add-Search-Filter')}}</span>

                                  </v-tooltip>





                                </v-badge>

                              </v-layout>

                            </v-flex>

                          </v-layout>

                        </v-card>

                      </v-flex>

                    </v-layout>

                  </v-form>

                </v-card>

              </v-flex>

              <v-flex xs12 sm12 md12 pb-3>

                <v-card flat class="white--text">

                  <v-card flat="">

                    <v-card-actions>

                      <v-layout row wrap>

                        <v-flex xs12 sm12>

                          <v-card flat>

                            <div class="musteri-karlilik-odeme-report-table">
                            <ReportTable
                              :headers="headers"
                              :items="itemssatis"
                              storage-key="musterikarlilikodemeraporu_columns"
                              :loading="progress"
                              :has-searched="itemssatis && itemssatis.length > 0"
                              :show-search="true"
                              :search-label="$t('Search')"
                              :show-frontend-export="true"
                              :export-title="$t('Customer-Profitability-With-Payment')"
                              :export-meta-items="musteriKarlilikOdemeExportMetaItems"
                              :export-summary-cards="musteriKarlilikOdemeSummaryCards"
                              :rows-per-page-items="[50, 100, 200, 500, 1000]"
                            ></ReportTable>
                          </div>

                          </v-card>

                        </v-flex>



                      </v-layout>

                    </v-card-actions>

                  </v-card>

                </v-card>

              </v-flex>

              <br />











            </v-layout>

          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"

            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">

            {{ text1 }}

            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>

          </v-snackbar>





          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="350px">

            <v-card flat color="grey lighten-4">

              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>

              <v-divider></v-divider>

              <v-card-text>

                <v-layout row="" wrap="">

                  <v-flex xs12 sm12 md12 pa-1>

                    <v-card flat class="white--text">

                      <v-card flat color="grey lighten-4">

                        <v-card-actions>

                          <v-layout row="" wrap="">



                            <v-flex xs12 sm6 md6>

                              <v-text-field hide-details :label="$t('Number-of-Days')" mask="######" v-model="Rapor.GunSayi">

                              </v-text-field>

                            </v-flex>

                            <v-flex xs12 sm6 md6>

                              <yuzdeinput :etiket="$t('Annual-Interest')" v-model="Rapor.YillikFaiz"

                                :autocomplete="'autocomplete'"></yuzdeinput>

                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <tarihcomp :etiket="$t('Date')" v-bind:defaultvalue="'ok'" :detaygizle="true"

                                v-bind:value="Rapor.Tarih" v-model="Rapor.Tarih"></tarihcomp>

                            </v-flex>

                          </v-layout>

                        </v-card-actions>

                      </v-card>

                    </v-card>

                  </v-flex>





                </v-layout>

              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>

                <v-spacer></v-spacer>

                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>

                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>

              </v-card-actions>

            </v-card>

          </v-dialog>

        </v-layout>

      </v-card>

    </v-app>

  </div>

</template>



<script>

  import auth from '../../../api/auth'

  import tarihcomp from '../customcomp/tarihim'

  import helpers from "@/components/app/customcomp/helpers.js"

  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"

  import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"

  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  import ReportTable from "@/components/app/customcomp/ReportTable.vue"

  export default {

    data() {

      return {

        mailDialog: false,

mailValid: false,

mailLoading: false,

mailPayload: {

  To: "",

  AgencyName: "",

  DocType: "Müşteri Kârlılık Raporu (Ödeme Eşleştirmeli) - Customer Profitability Report (With Payment Matching)",

  AgentFullName: "",

  CustomBody: ""

},

rules: {

  required: v => !!v || 'Zorunlu alan',

  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'

},

        PB:'TRY',

        sayfayetki: {

          Screen: false,

          Update: false,

          Save: false,

          Delete: false,

          Status: false,

          Message: null,

          islem: 0,

        },

        filtrevarmi: false,

        referansitems: [],

        search: '',

        searchsatilanbilet: null,
        headers: [{
            text: this.$t('Date'),
            value: 'Tarih',
            visible: true,
            sortable: true,
            type: 'date',
            align: 'left',
            width: '150px'
          },
          {
            text: this.$t('Document-No'),
            value: 'EvrakNo',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '170px'
          },
          {
            text: this.$t('Type'),
            value: 'Tip',
            visible: true,
            sortable: true,
            type: 'text',
            align: 'left',
            width: '150px'
          },
          {
            text: this.$t('Maturity-Date'),
            value: 'Vade',
            visible: true,
            sortable: true,
            type: 'date',
            align: 'left',
            width: '150px'
          },
          {
            text: this.$t('Late-Interest'),
            value: 'VadeFark',
            align: 'right',
            visible: true,
            sortable: true,
            type: 'money',
            width: '170px'
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
            align: 'right',
            visible: true,
            sortable: true,
            type: 'money',
            width: '170px'
          }
        ],
        genelToplamlar: {

          ToplamTutar: 0,

          ToplamVadeFark: 0

        },



        hesapgrubu: [],

        nohesapgrubu: [],

        Rapor: {

          BaslangicTarih: null,

          BitisTarih: null,

          YillikFaiz: 0,

          GunSayi: 360,

          Cari: {

            Kod: null,

          },

          SirketKodu: null,

          Tarih: null

        },

        valid: true,

        tumsirketler: '',

        loadingana: false,

        loading: false,

        items: [],

        load: false,

        load1: true,

        search3: '',

        renk1: 'info',

        dialogfiltre: false,

        hesapkodu: [],

        statecari: [],

        searchcari: '',

        statecariana: [],

        searchcariana: '',

        progress: false,

        tooltip: false,

        el: null,

        yok: false,

        itemssatis: [],

        butondurum: true,

        snackbar: false,

        y: 'top',

        x: 'right',

        mode: '',

        timeout: 6000,

        text1: '',

        dictionary: {

          custom: {

            tarihsec: {

              required: () => this.$t('Please-select-a-date')

            },

            tarihsec1: {

              required: () => this.$t('Please-select-a-date')

            },

          }

        },

      }

    },

    beforeRouteEnter(to, from, next) {

      next(vm => {

        vm.prevRoute = from.path

      })

    },

    beforeMount: beforeMount,

    mounted() {

      this.$validator.localize('en', this.dictionary)

      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        this.Rapor.Yil = helpers.getYear();

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.PB=credentials.ParaBirimi;

        var params3 = {

          CompanyCode: credentials.SirketKodu

        }



        this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.hesapgurubu = response.body

          this.nohesapgrubu = response.body

        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

          } else {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

          }

        })



        // this.$http.post(auth.API_URL + 'api/Reference/List', params3, {

        //   headers: {

        //     'Authorization': 'Bearer ' + auth.getAuthHeader()

        //   }

        // }).then((response) => {

        //   this.referansitems = response.body

        // }, (response) => {

        //   if (response.status === 0) {

        //     this.text1 = 'Service Unavailable'

        //     this.snackbar = true

        //   } else {

        //     this.text1 = 'Service Unavailable'

        //     this.snackbar = true

        //   }

        // })







        this.$http.post(auth.API_URL + 'api/doctype/List', params3, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.evraktipi = response.body

        }, (response) => {

          if (response.status === 0) {

          } else {

          }

        })



      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {

              let url = '#' + this.prevRoute

              window.open(url, '_self')

            } else {

              let url = '#/'

              window.open(url, '_self')

            }

          }

        });

      }

    },

    filters: {

      dateformat: function (t) {

        return helpers.dateformat(t);

      },

      moneyformat: function (m) {

        return helpers.moneyformat(m);

      },

      bakiyekontrol: function (m) {

        return helpers.bakiyekontrol(m);

      }

    },

    components: {

      'tarihcomp': tarihcomp,

      referansmerkezicomp,

      yuzdeinput,

      yetkidialog,

      cariaracomp,
      ReportTable

    },


    computed: {
      musteriKarlilikOdemeExportMetaItems() {
        return [
          {
            label: this.$t('Starting-Date'),
            value: this.Rapor ? this.Rapor.BaslangicTarih : '',
            type: 'date'
          },
          {
            label: this.$t('Finishing-Date'),
            value: this.Rapor ? this.Rapor.BitisTarih : '',
            type: 'date'
          },
          {
            label: this.$t('Accound-Code'),
            value: this.Rapor && this.Rapor.Cari ? this.Rapor.Cari.Kod : ''
          },
          {
            label: this.$t('Number-of-Days'),
            value: this.Rapor ? this.Rapor.GunSayi : ''
          },
          {
            label: this.$t('Annual-Interest'),
            value: this.Rapor ? this.Rapor.YillikFaiz : ''
          },
          {
            label: this.$t('Date'),
            value: this.Rapor ? this.Rapor.Tarih : '',
            type: 'date'
          }
        ]
      },

      musteriKarlilikOdemeSummaryCards() {
        return [
          {
            title: this.$t('Customer-Profitability-With-Payment'),
            items: [
              {
                label: this.$t('Total-Delay-Interest'),
                value: this.genelToplamlar ? this.genelToplamlar.ToplamVadeFark : 0,
                type: 'money'
              },
              {
                label: this.$t('totalamount'),
                value: this.genelToplamlar ? this.genelToplamlar.ToplamTutar : 0,
                type: 'money'
              }
            ]
          }
        ]
      }
    },

    watch: {

    },

    methods: {

  getparabirimi() {

    return helpers.getparabirimi();

  },

  openMailDialog() {

    if (!this.mailPayload) this.mailPayload = {};

    this.mailPayload.DocType = "Müşteri Kârlılık Raporu (Ödeme Eşleştirmeli) - Customer Profitability Report (With Payment Matching)";

    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {

      this.$refs.mailForm.resetValidation();

    }

    this.mailDialog = true;

  },

  closeMailDialog() {

    this.mailDialog = false;

  },

  sendMail() {

    if (!(this.$refs && this.$refs.mailForm && this.$refs.mailForm.validate && this.$refs.mailForm.validate())) return;

    if (!(this.$refs && this.$refs.formgunluksatis && this.$refs.formgunluksatis.validate && this.$refs.formgunluksatis.validate())) return;

    const credsRaw = window.localStorage.getItem('credentials');

    const creds = credsRaw ? JSON.parse(credsRaw) : {};

    const companyCode = this.tumsirketler === true ? '0' : (creds && creds.SirketKodu ? creds.SirketKodu : null);

    const R = JSON.parse(JSON.stringify(this.Rapor || {}));

    R.SirketKodu = companyCode;

    if (R.GunSayi == null || R.GunSayi < 1) R.GunSayi = 360;

    const mp = this.mailPayload || {};

    const payload = {

      Input: R,

      Mail: {

        To: mp.To || "",

        AgencyName: mp.AgencyName || "",

        DocType: mp.DocType || "Müşteri Kârlılık Raporu (Ödeme Eşleştirmeli) - Customer Profitability Report (With Payment Matching)",

        AgentFullName: mp.AgentFullName || "",

        CustomBody: mp.CustomBody || ""

      }

    };

    this.mailLoading = true;

    const endpoint = auth.API_URL + 'api/Report/MailGonderMusteriKarlilikOdemeExcel';

    this.$http.post(endpoint, payload, { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } })

      .then(() => {

        this.mailLoading = false;

        this.mailDialog = false;

        this.text1 = this.$t ? this.$t('Email-sent') : 'Mail gönderildi.';

        this.snackbar = true;

      }, (err) => {

        this.mailLoading = false;

        const body = (err && (err.body || err.data)) ? (err.body || err.data) : {};

        const msg = (body && (body.Message || body.message)) || err.statusText || (this.$t ? this.$t('Email-send-failed') : 'Mail gönderilemedi.');

        this.text1 = msg;

        this.snackbar = true;

      });

  },

      getList: getList,

      getListHtml: getListHtml,

      getListExcel: getListExcel,

      filtrele: filtrele,

      filtrekayit: filtrekayit,

      filtreiptal: filtreiptal

    }

  }



  function filtrele() {

    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {

      CompanyCode: credentials.SirketKodu

    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.itemsairlinelist = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable'

        this.progress = false

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable'

        this.progress = false

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.hesapgrubu = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.doviztipi = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable-Döviz'

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable-Döviz'

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.masrafmerkezi = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = 'Service Unavailable-ExpenseCenter'

        this.snackbar = true

      } else {

        this.text1 = 'Service Unavailable-ExpenseCenter'

        this.snackbar = true

      }

    })

  }



  function filtrekayit() {

    this.filtrevarmi = true

    this.dialogfiltre = false

    this.getList()

  }

  function filtreiptal() {

    this.filtrevarmi = false

    this.dialogfiltre = false

    this.Rapor.SirketKodu = null

    this.Rapor.Cari.Kod = null

    this.Rapor.Tarih = ''

    this.Rapor.GunSayi = null

    this.Rapor.YillikFaiz = 0

  }

  function getList() {

    if (this.$refs.formgunluksatis.validate()) {

      this.progress = true

      this.load1 = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {

        this.Rapor.SirketKodu = '0'

      } else {

        this.Rapor.SirketKodu = credentials.SirketKodu

      }

      if (this.Rapor.GunSayi == null || this.Rapor.GunSayi < 1) {

        this.Rapor.GunSayi = 360

      }

      var params = this.Rapor

      this.$http.post(auth.API_URL + 'api/Report/CustomerProfitPaymentReport', params, {

        headers: {

          'Authorization': 'Bearer ' + auth.getAuthHeader()

        }

      }).then((response) => {

        this.itemssatis = response.body.DetayList

        this.genelToplamlar.ToplamVadeFark = response.body.ToplamVadeFark

        this.genelToplamlar.ToplamTutar = response.body.ToplamTutar

        this.progress = false

        this.load1 = true

      }, (response) => {

        if (response.status === 0) {

          this.text1 = 'Service Unavailable-CustomerProfitReport'

          this.snackbar = true

          this.progress = false

          this.load1 = true

        } else {

          this.text1 = 'Service Unavailable-CustomerProfitReport'

          this.snackbar = true

          this.progress = false

          this.load1 = true

        }

      })

    }

  }





  function getListHtml() {



    if (this.$refs.formgunluksatis.validate()) {

      this.progress = true

      this.load1 = false





      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var lang = localStorage.getItem('lang')

      if (this.tumsirketler === true) {

        this.Rapor.SirketKodu = '0'

      } else {

        this.Rapor.SirketKodu = credentials.SirketKodu

      }

      if (this.Rapor.GunSayi == null || this.Rapor.GunSayi < 1) {

        this.Rapor.GunSayi = 360

      }

      var params = this.Rapor

      this.$http

        .post(auth.API_URL + "api/Report/CustomerProfitPaymentReportHtml", params, {

          headers: {

            Authorization: "Bearer " + auth.getAuthHeader()

          }

        }).then((response) => {

          if (lang=='en')

          {

             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);

             bodyhtml=bodyhtml.toString().replace('<title> MÜŞTERİ KARLILIK RAPORU (ÖDEME EŞLEŞTİRMELİ) </title>','<title> CUSTOMER PROFITABILITY REPORT </title>');

             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>MÜŞTERİ KARLILIK RAPORU (ÖDEME EŞLEŞTİRMELİ)</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>CUSTOMER PROFITABILITY REPORT</font>")

             bodyhtml=bodyhtml.toString().replace("Tarih :","Date :")

             bodyhtml=bodyhtml.toString().replace("Gün Sayısı :","Days :")

             bodyhtml=bodyhtml.toString().replace("Yıllık Faiz :"," Annual Interest:")

             bodyhtml=bodyhtml.toString().replace("TOPLAM :","TOTAL :")

             bodyhtml=bodyhtml.toString().replace("Vade Farkı","Maturity Difference")

             response.bodyText=bodyhtml;

          }

          this.progress = false

          this.load1 = true

          var blob = new Blob([response.bodyText], {

            type: 'application/html'

          });

          var link = document.createElement('a');

          link.href = window.URL.createObjectURL(blob);

          link.download =this.$t('CustomerProfPaymentReport') + ".html";

          link.click();

        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          } else {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          }

        })

    }

  }



  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {

      this.progress = true

      this.load1 = false





      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {

        this.Rapor.SirketKodu = '0'

      } else {

        this.Rapor.SirketKodu = credentials.SirketKodu

      }

      if (this.Rapor.GunSayi == null || this.Rapor.GunSayi < 1) {

        this.Rapor.GunSayi = 360

      }

      var params = this.Rapor

      this.$http

        .post(auth.API_URL + "api/Report/CustomerProfitPaymentReportExcel", params, {

          headers: {

            Authorization: "Bearer " + auth.getAuthHeader()

          },

          responseType: "arraybuffer"

        }).then((response) => {



          this.progress = false

          this.load1 = true

          var blob = new Blob([response.data], {

            type: 'application/xlsx'

          });

          var link = document.createElement('a');

          link.href = window.URL.createObjectURL(blob);

          link.download = this.$t('CustomerProfPaymentReport') + ".xlsx";

          link.click();

        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          } else {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          }

        })

    }

  }



  function beforeMount() {





  }

</script>

<style scoped>

/* Bu stiller yalnızca musterikarlilikodemeraporu.vue sayfasına özeldir. */
.musteri-karlilik-odeme-report-table {
  width: 100%;
  margin-top: 4px;
}

.musteri-karlilik-odeme-report-table > * {
  width: 100%;
}

</style>
